/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2021-02-01T17:09:50.449
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import BasicLayout from '@/layouts/basic-layout';

const meta = {
auth: true
};

const pre = 'financial-FinancialAdjustmentApply-'

export default 
{
path: '/financial/financialadjustmentapply',
name: 'financial-FinancialAdjustmentApply',
redirect: {
name: '${pre}-index'
}
,

meta:{
...meta,
},

component: BasicLayout ,
children:
[
{
path: 'index',
name: '${pre}FinancialAdjustmentApply-index',

meta:{
...meta,
title: '财务调整申请单'
},

component: () => import('@/pages/financial/financialadjustmentapply/index') ,
},
{
path: 'detail-edit/:id',
name: '${pre}FinancialAdjustmentApply-detail-edit',
auth: [
'hidden'
],

meta:{
...meta,
title: '财务调整申请单编辑'
},

component: () => import('@/pages/financial/financialadjustmentapply/detail-edit') ,
},
{
path: 'detail-edit',
name: '${pre}FinancialAdjustmentApplydetail-create',
auth: [
'hidden'
],

meta:{
...meta,
title: '财务调整申请单新增'
},

component: () => import('@/pages/financial/financialadjustmentapply/detail-edit') ,
},
{
path: 'detail-view/:id',
name: '${pre}FinancialAdjustmentApplyView',
auth: [
'hidden'
],

meta:{
...meta,
title: '财务调整申请单详情查看'
},

component: () => import('@/pages/financial/financialadjustmentapply/detail-view') ,
},
]
};
